import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React, { Fragment } from 'react';
import { useTheme } from '../../theme-context';

const TicketCheckoutLineHeader = (): JSX.Element => {
    const { getFont } = useTheme();

    return (
        <Fragment>
            <div
                key="section"
                data-testid="section"
                className={css({
                    fontFamily: getFont('desktop/body/small').fontFamily,
                    fontWeight: getFont('desktop/body/small').fontWeight,
                    fontSize: getFont('desktop/body/small').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/small').lineHeightPx
                    }px`,
                    marginBottom: '4px',
                })}
            >
                {gettext('SECTION')}
            </div>
            <div
                key="variant"
                data-testid="variant"
                className={css({
                    fontFamily: getFont('desktop/body/small').fontFamily,
                    fontWeight: getFont('desktop/body/small').fontWeight,
                    fontSize: getFont('desktop/body/small').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/small').lineHeightPx
                    }px`,
                    marginBottom: '4px',
                })}
            >
                {gettext('TYPE')}
            </div>
            <div
                key="row"
                data-testid="row"
                className={css({
                    justifySelf: 'center',
                    fontFamily: getFont('desktop/body/small').fontFamily,
                    fontWeight: getFont('desktop/body/small').fontWeight,
                    fontSize: getFont('desktop/body/small').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/small').lineHeightPx
                    }px`,
                    marginBottom: '4px',
                })}
            >
                {gettext('ROW')}
            </div>
            <div
                key="seat"
                data-testid="seat"
                className={css({
                    justifySelf: 'center',
                    fontFamily: getFont('desktop/body/small').fontFamily,
                    fontWeight: getFont('desktop/body/small').fontWeight,
                    fontSize: getFont('desktop/body/small').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/small').lineHeightPx
                    }px`,
                    marginBottom: '4px',
                })}
            >
                {gettext('SEAT')}
            </div>
            <div
                key="tier"
                data-testid="tier"
                className={css({
                    fontFamily: getFont('desktop/body/small').fontFamily,
                    fontWeight: getFont('desktop/body/small').fontWeight,
                    fontSize: getFont('desktop/body/small').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/small').lineHeightPx
                    }px`,
                    marginBottom: '4px',
                })}
            >
                {gettext('TIER')}
            </div>
            <div
                key="remove-ticket"
                data-testid="remove-ticket"
                className={css({
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/small').lineHeightPx
                    }px`,
                    marginBottom: '4px',
                })}
            />
        </Fragment>
    );
};

export default TicketCheckoutLineHeader;
